if (!customElements.get('fct-utm-promo-bar')) {
  customElements.define('fct-utm-promo-bar', class extends HTMLElement {
    connectedCallback() {
      this.onSectionLoad = () => this.mount();
      document.addEventListener('shopify:section:load', this.onSectionLoad);
      this.mount();
    }

    disconnectedCallback() {
      document.removeEventListener('shopify:section:load', this.onSectionLoad);
      this.unmount();
    }

    isEligible() {
      if (window.Shopify?.designMode) return true;
      const condition = (this.dataset.utmContains || '').trim();
      if (!condition) return false;

      const matched = window.location.href.includes(condition);
      const key = 'show_promo_bar_' + this.dataset.sectionId;
      try {
        // Store the condition so changing a campaign cannot reuse an old match.
        if (matched) window.sessionStorage.setItem(key, condition);
        return matched || window.sessionStorage.getItem(key) === condition;
      } catch (error) {
        // URL targeting still works when browser storage is unavailable.
        return matched;
      }
    }

    mount() {
      const target = document.querySelector('[data-utm-promo-bars]');
      if (this.bar?.parentNode === target && target) return;
      this.unmount();
      if (!target || !this.isEligible()) return;

      const template = this.querySelector('template');
      if (!template) return;
      this.bar = template.content.firstElementChild.cloneNode(true);
      target.appendChild(this.bar);

      const slides = Array.from(this.bar.querySelectorAll('.utm-promo-bar__slide'));
      if (slides.length > 1 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        let index = 0;
        this.timer = window.setInterval(() => {
          if (this.bar.matches(':hover') || this.bar.contains(document.activeElement)) return;
          slides[index].hidden = true;
          index = (index + 1) % slides.length;
          slides[index].hidden = false;
        }, 6000);
      }
    }

    unmount() {
      window.clearInterval(this.timer);
      this.bar?.remove();
      this.bar = null;
    }
  });
}
